<template>
    <div class="cta-caja cta-caja--lila" @click="clicking">
      <div class="cta-caja__cover">
        <img
          class="cta-caja__cover-desk"
          src="../../../assets/img/covers/cover-cta-libro-lucia.jpg"
          alt=""
        />
        <img
          class="cta-caja__cover-mobile"
          src="../../../assets/img/covers/cover-cta-libro-lucia-m.png"
          alt=""
        />
      </div>
      <div class="cta-caja__content">
        <h4 class="cta-caja__title">El gran libro de Lucía, mi pediatra</h4>
        <div class="cta-caja__description">
          <p>Lo más parecido que hemos encontrado a un manual de instrucciones para tu bebé.</p>
        </div>
        <div class="cta-caja__actions">
          <loading-button v-if="loading" :class="'button-loading--sm'" />
          <button
            v-else
            class="button button--accent button--sm button--ico"
            @click.stop="addProduct('Constructor - Banner Horitzontal')"
            :disabled="added"
          >
            {{ buttonText }}
          </button>
        </div>
      </div>
      <modal-dialog
          :show="showProductAddedDialog"
          @close="showProductAddedDialog = false"
          target-class="modal__card--mini"
      >
        <product-added-to-list/>
      </modal-dialog>
    </div>
  </template>
  
  <script>
  import Product from "./Mixins/Product";
  import LoadingButton from "../../../components/LoadingButton";
  import ModalDialog from "../../../components/ui/ModalDialog";
  import ProductAddedToList from "../../../components/ProductAddedToList";
  
  export default {
    name: "CtaLibroLucia",
    mixins: [Product],
    components: {
      LoadingButton,
      ModalDialog,
      ProductAddedToList
    },
    computed: {
      buttonText() {
        return this.added ? "Añadido" : "Añadir a mi lista";
      },
    },
    created() {
      this.product = {
        id: 42060,
        name: "El gran libro de Lucía mi pediatra",
        "brand-slug": "el-gran-libro-de-lucia-mi-pediatra",
        retailerName: "Amazon",
        productRetailers: [{"name": "Amazon"}]
      };
    },
    methods: {
      clicking()
      {
        mixpanel.track("Click element constructor", {
          "Name": "El gran libro de Lucía mi pediatra",
          "Section": "Secció inicial",
          "Section number": 0,
          "Type": "Banner - Horizontal",
          "Content": "Ecommerce"
        });
        this.browseProduct();
      }
    }
  };
  </script>